import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordSuccessComponent } from './password-success/password-success.component';
import { ManageSubscriptionsComponent } from './manage-subscriptions/manage-subscriptions.component';
//import { CompanyStoresComponent } from './company-stores/company-stores.component';
import { AddCompanyStoresComponent } from './add-company-stores/add-company-stores.component';
import {AuthGuardService} from './auth-guard.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddProductSubscriptionsComponent } from './add-product-subscriptions/add-product-subscriptions.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ProductPaymentComponent } from './product-payment/product-payment.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { OrderSuccessComponent } from './order-success/order-success.component'; 
import { ManageCompanyComponent } from './manage-company/manage-company.component';
import { AllotLicenseComponent } from './allot-license/allot-license.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { SubAdminComponent } from './sub-admin/sub-admin.component';
const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password/:id', component: ResetPasswordComponent },
  { path: 'subscriptions', component: SubscriptionsComponent,canActivate:[AuthGuardService] },
  { path: 'profile', component: ProfileComponent,canActivate:[AuthGuardService] },
  { path: 'manage-subscriptions/:id', component: ManageSubscriptionsComponent,canActivate:[AuthGuardService]},
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'password-success', component: PasswordSuccessComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyComponent },
  //{ path: 'company-store-2', component: CompanyStoresComponent,canActivate:[AuthGuardService] },
  { path: 'company-store', component: ManageCompanyComponent,canActivate:[AuthGuardService] },
  { path: 'add-company-store', component: AddCompanyStoresComponent,canActivate:[AuthGuardService] },
  {path: 'dashboard' ,component:DashboardComponent,canActivate:[AuthGuardService]},
  {path: 'add-product-subscriptions/:id' ,component:AddProductSubscriptionsComponent,canActivate:[AuthGuardService]},
  {path: 'add-product-subscriptions' ,component:AddProductSubscriptionsComponent,canActivate:[AuthGuardService]},
  {path: 'notifications' ,component:NotificationsComponent,canActivate:[AuthGuardService]},
  {path: 'payments' ,component:ProductPaymentComponent,canActivate:[AuthGuardService]},
  {path: 'order-success' ,component:OrderSuccessComponent,canActivate:[AuthGuardService]},
  {path: 'checkout/:id' ,component:CheckoutComponent,canActivate:[AuthGuardService]},
  {path: 'allot-license' ,component:AllotLicenseComponent,canActivate:[AuthGuardService]},
  {path: 'users' ,component:AdminUsersComponent,canActivate:[AuthGuardService]},
  {path: 'sub-admin' ,component:SubAdminComponent,canActivate:[AuthGuardService]},
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
